<template lang="pug">
  v-container#index-view( fluid pa-0 )
    v-layout( row wrap )
      v-flex( xs12 )
        v-card( dark )
          v-card-text( class="py-5" )
            h1.display-2 Módulo Inventario
            span.subheading Despacho, Abastecimiento, Inventario y Bodegas
</template>

<script>
  export default {
    created(){
      this.setTitle( "Bienvenido" )
    },
  }
</script>

<style>
  #index-view .v-btn__content {
    font-size: 18px !important;
  }
</style>